/**
 * 
 * @param {array} pages Required
 * @param {string} pageType Required
 * @returns {object | null}
 */
export const pageByType = (pages, pageType) => {
    if (!pages?.length || !pageType) return null;

    return pages.find(({type}) => type === pageType) || null;
};
